export var NormieRowType;
(function (NormieRowType) {
    NormieRowType["HEADER"] = "header";
    NormieRowType["ROW"] = "row";
})(NormieRowType || (NormieRowType = {}));
export const MOBILE_HOME_ITEM_TYPES = {
    SAFE_SEARCH: 'SAFE_SEARCH',
    USER_FUNDS: 'USER_FUNDS',
    RECENT_RESULTS: 'RECENT_RESULTS',
    NORMIE_CATEGORIES: 'NORMIE_CATEGORIES',
    MEME_MODE: 'MEME_MODE',
    RECENTLY_LISTED_HEADER: 'RECENTLY_LISTED_HEADER',
    TOKEN_RESULT: 'TOKEN_RESULT',
    TOP_GAINERS: 'TOP_GAINERS',
    TRENDING_TITLE: 'TRENDING_TITLE',
    LOADING: 'LOADING',
    TOP_10_HEADER: 'TOP_10_HEADER',
    ALL_TOKENS_HEADER: 'ALL_TOKENS_HEADER',
    LOW_VOLUME_BUTTON: 'LOW_VOLUME_BUTTON',
    NO_RESULTS: 'NO_RESULTS',
    CASH_RESULTS: 'CASH_RESULTS',
    LAUNCHPAD: 'LAUNCHPAD',
    SAVED_HEADER: 'SAVED_HEADER',
    UNVERIFIED_WARNING: 'UNVERIFIED_WARNING',
    SEARCH_WARNING: 'SEARCH_WARNING',
};
export const MOBILE_PORTFOLIO_ITEM_TYPES = {
    TOTAL_PORTFOLIO: 'TOTAL_PORTFOLIO',
    ACTIONS: 'ACTIONS',
    CHART: 'CHART',
    PORTFOLIO_HEADER: 'PORTFOLIO_HEADER',
    ASSET_ROW: 'ASSET_ROW',
};
